(function () {
  var COLOR_MAP = [
    { terms: ['sky blue', 'sky'], value: '#79c7ee' },
    { terms: ['royal blue', 'royal'], value: '#1f63d6' },
    { terms: ['navy blue', 'navy'], value: '#172a4f' },
    { terms: ['forest green', 'bottle green'], value: '#006b46' },
    { terms: ['green'], value: '#008d4f' },
    { terms: ['maroon', 'burgundy'], value: '#7a1f3d' },
    { terms: ['red'], value: '#d71920' },
    { terms: ['orange'], value: '#f59e0b' },
    { terms: ['gold'], value: '#f5b400' },
    { terms: ['yellow'], value: '#ffd22e' },
    { terms: ['black'], value: '#111111' },
    { terms: ['charcoal'], value: '#36454f' },
    { terms: ['grey', 'gray'], value: '#9ca3af' },
    { terms: ['white'], value: '#ffffff' },
    { terms: ['purple'], value: '#6d28d9' },
    { terms: ['pink'], value: '#f472b6' },
    { terms: ['teal'], value: '#0f9f9a' },
    { terms: ['blue'], value: '#2563eb' }
  ];

  function normalize(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, 'and')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();
  }

  function colourToCss(value) {
    var normalized = normalize(value);
    var match = COLOR_MAP.find(function (entry) {
      return entry.terms.some(function (term) {
        return normalized === term || normalized.indexOf(term) !== -1;
      });
    });

    return match ? match.value : '#d1d5db';
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.money_format || '${{amount}}');
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function safeParseJson(script) {
    if (!script) return [];

    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  }

  function parseSelectedItems(value) {
    if (!value) return [];

    try {
      var items = JSON.parse(value);

      if (!Array.isArray(items)) return [];

      return items.filter(function (item) {
        return item && item.id;
      });
    } catch (error) {
      return [];
    }
  }

  function firstAvailableVariant(product) {
    if (!product || !Array.isArray(product.variants)) return null;

    return product.variants.find(function (variant) {
      return variant.available;
    }) || product.variants[0] || null;
  }

  function firstAvailableProduct(products) {
    return products.find(function (product) {
      return product.available && firstAvailableVariant(product);
    }) || products[0] || null;
  }

  function findMatchingProduct(products, jerseyColour) {
    var normalizedJerseyColour = normalize(jerseyColour);
    var availableProducts = products.filter(function (product) {
      return product.available && firstAvailableVariant(product);
    });
    var exactMatch = availableProducts.find(function (product) {
      return normalize(product.colour) === normalizedJerseyColour;
    });
    var looseMatch = availableProducts.find(function (product) {
      var productColour = normalize(product.colour);

      return normalizedJerseyColour &&
        productColour &&
        (productColour.indexOf(normalizedJerseyColour) !== -1 ||
          normalizedJerseyColour.indexOf(productColour) !== -1);
    });

    return exactMatch || looseMatch || firstAvailableProduct(products);
  }

  function findVariantByTitle(product, title) {
    if (!product || !title) return null;

    return product.variants.find(function (variant) {
      return variant.available && variant.title === title;
    }) || null;
  }

  function buildGroup(root, row) {
    var products = safeParseJson(row.querySelector('[data-complete-kit-products]'));
    var defaultProduct = findMatchingProduct(products, root.dataset.jerseyColour);
    var defaultVariant = firstAvailableVariant(defaultProduct);
    var swatches = Array.prototype.slice.call(row.querySelectorAll('[data-complete-kit-swatch]'));

    swatches.forEach(function (swatch) {
      var product = products.find(function (item) {
        return String(item.id) === String(swatch.dataset.productId);
      });

      swatch.style.setProperty('--kit-swatch-color', colourToCss(swatch.dataset.colour));
      swatch.disabled = !product || !product.available || !firstAvailableVariant(product);
    });

    return {
      root: root,
      row: row,
      label: row.dataset.kitLabel || '',
      products: products,
      selected: false,
      selectedProduct: defaultProduct,
      selectedVariant: defaultVariant,
      image: row.querySelector('[data-complete-kit-image]'),
      title: row.querySelector('[data-complete-kit-title]'),
      salePrice: row.querySelector('[data-complete-kit-sale-price]'),
      comparePrice: row.querySelector('[data-complete-kit-compare-price]'),
      addButton: row.querySelector('[data-complete-kit-add]'),
      addText: row.querySelector('[data-complete-kit-add-text]'),
      controls: row.querySelector('[data-complete-kit-controls]'),
      swatches: swatches,
      colourLabel: row.querySelector('[data-complete-kit-selected-colour]'),
      sizeSelect: row.querySelector('[data-complete-kit-size]')
    };
  }

  function renderSizeOptions(group) {
    var select = group.sizeSelect;
    var product = group.selectedProduct;
    var selectedVariant = group.selectedVariant;

    if (!select || !product || !Array.isArray(product.variants)) return;

    select.innerHTML = '';

    product.variants.forEach(function (variant) {
      var option = document.createElement('option');
      option.value = variant.id;
      option.textContent = variant.title === 'Default Title' ? 'One Size' : variant.title;
      option.disabled = !variant.available;
      select.appendChild(option);
    });

    if (selectedVariant) {
      select.value = String(selectedVariant.id);
    }

    select.disabled = product.variants.length <= 1;
  }

  function renderGroup(group) {
    var product = group.selectedProduct;
    var variant = group.selectedVariant;
    var discount = parseFloat(group.root.dataset.discountPercent) || 0;

    group.row.classList.toggle('is-selected', group.selected);

    if (group.controls) {
      group.controls.hidden = !group.selected;
    }

    if (group.addButton) {
      group.addButton.disabled = !product || !variant || !variant.available;
      group.addButton.classList.toggle('is-added', group.selected);
      group.addButton.setAttribute('aria-pressed', group.selected ? 'true' : 'false');
    }

    if (group.addText) {
      group.addText.textContent = group.selected ? 'Added' : '+ Add';
    }

    if (product && group.title) {
      group.title.textContent = product.title;
    }

    if (product && group.image) {
      group.image.innerHTML = '';

      if (product.image) {
        var image = document.createElement('img');
        image.src = product.image;
        image.alt = product.title;
        image.loading = 'lazy';
        image.width = 80;
        image.height = 80;
        group.image.appendChild(image);
      }
    }

    if (variant && group.salePrice && group.comparePrice) {
      group.salePrice.innerHTML = formatMoney(Math.round(variant.price * (100 - discount) / 100));
      group.comparePrice.innerHTML = formatMoney(variant.price);
    }

    if (group.colourLabel) {
      group.colourLabel.textContent = product ? product.colour : '';
    }

    group.swatches.forEach(function (swatch) {
      var isActive = product && String(product.id) === String(swatch.dataset.productId);
      swatch.classList.toggle('is-active', isActive);
      swatch.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    renderSizeOptions(group);
  }

  function updateSelectedItems(root, groups) {
    var input = root.querySelector('[data-complete-kit-selected-items]');
    var productTitle = root.dataset.productTitle || '';
    var discount = root.dataset.discountPercent || '0';

    if (!input) return;

    var selectedItems = groups
      .filter(function (group) {
        return group.selected && group.selectedVariant && group.selectedVariant.available;
      })
      .map(function (group) {
        return {
          id: group.selectedVariant.id,
          quantity: 1,
          properties: {
            _complete_kit: 'true',
            _complete_kit_accessory: group.label,
            _complete_kit_colour: group.selectedProduct ? group.selectedProduct.colour : '',
            _complete_kit_size: group.selectedVariant.title === 'Default Title' ? 'One Size' : group.selectedVariant.title,
            _complete_kit_discount: discount + '%',
            _complete_kit_parent_product: productTitle
          }
        };
      });

    var selectedValue = JSON.stringify(selectedItems);

    input.value = selectedValue;
    syncSelectedItemsToForm(root, selectedValue);
    updatePreview(root, groups);
  }

  function updatePreview(root, groups) {
    var previewItems = Array.prototype.slice.call(root.querySelectorAll('.product-complete-kit__preview-item'));
    var previewGroups = groups.slice(0, 2).filter(function (group) {
      return group.selectedProduct && group.selectedProduct.image;
    });

    previewItems.forEach(function (preview, index) {
      preview.innerHTML = '';

      if (!previewGroups[index]) return;

      var image = document.createElement('img');
      image.src = previewGroups[index].selectedProduct.image;
      image.alt = '';
      image.loading = 'lazy';
      preview.appendChild(image);
    });
  }

  function selectProduct(group, product) {
    var currentSize = group.selectedVariant ? group.selectedVariant.title : '';
    group.selectedProduct = product;
    group.selectedVariant = findVariantByTitle(product, currentSize) || firstAvailableVariant(product);
  }

  function getProductForm(root) {
    var productId = root.dataset.productId;

    return productId
      ? document.querySelector('[data-type="add-to-cart-form"][data-terms-product="' + productId + '"]')
      : null;
  }

  function ensureFormSelectedInput(root) {
    var form = getProductForm(root);
    var productId = root.dataset.productId;
    var input;

    if (!form || !productId) return null;

    input = form.querySelector('[data-complete-kit-form-selected-items][data-product-id="' + productId + '"]');

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.setAttribute('data-complete-kit-form-selected-items', '');
      input.setAttribute('data-product-id', productId);
      form.appendChild(input);
    }

    return input;
  }

  function syncSelectedItemsToForm(root, value) {
    var input = ensureFormSelectedInput(root);

    if (input) {
      input.value = value || '[]';
    }
  }

  function getFormKitItems(form) {
    var input = form ? form.querySelector('[data-complete-kit-form-selected-items], [data-complete-kit-selected-items]') : null;
    var items = parseSelectedItems(input && input.value);
    var productId = form && form.dataset ? form.dataset.termsProduct : null;
    var fallbackInputs;

    if (items.length || !productId) return items;

    fallbackInputs = Array.prototype.slice.call(
      document.querySelectorAll('[data-complete-kit-selected-items][data-product-id="' + productId + '"]')
    );
    input = fallbackInputs.find(function (fallbackInput) {
      return fallbackInput.value && fallbackInput.value !== '[]';
    }) || fallbackInputs[0];

    return parseSelectedItems(input && input.value);
  }

  function getAjaxCartRoot() {
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

    if (!root && window.routes) {
      root = window.routes.root || '/';
    }

    if (root.slice(-1) !== '/') {
      root += '/';
    }

    return root;
  }

  function appendExternalProperties(form, formData) {
    Array.prototype.slice.call(document.querySelectorAll('[name^="properties"]')).forEach(function (field) {
      if (!field.name || form.contains(field)) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      if (field.type === 'file') return;

      formData.append(field.name, field.value);
    });
  }

  function buildKitCartPayload(form, kitItems) {
    var formData = new FormData(form);
    var propertyPattern = /^properties\[(.+)\]$/;
    var properties = {};
    var mainItem;

    appendExternalProperties(form, formData);

    mainItem = {
      id: formData.get('id'),
      quantity: parseInt(formData.get('quantity') || '1', 10) || 1
    };

    formData.forEach(function (value, key) {
      var match = key.match(propertyPattern);

      if (!match || value == null || value === '') return;
      if (typeof File !== 'undefined' && value instanceof File) return;

      properties[match[1]] = value;
    });

    if (Object.keys(properties).length) {
      mainItem.properties = properties;
    }

    if (formData.get('selling_plan')) {
      mainItem.selling_plan = formData.get('selling_plan');
    }

    return {
      items: [mainItem].concat(kitItems.map(function (item) {
        return {
          id: item.id,
          quantity: parseInt(item.quantity || '1', 10) || 1,
          properties: item.properties || {}
        };
      }))
    };
  }

  function showTermsMessage(form) {
    var productId = form && form.dataset ? form.dataset.termsProduct : null;

    if (!productId) return;

    document
      .querySelectorAll('[data-product-terms-message][data-terms-product="' + productId + '"]')
      .forEach(function (message) {
        message.hidden = false;
      });
  }

  function termsAccepted(form) {
    var productId = form && form.dataset ? form.dataset.termsProduct : null;
    var checkbox = productId
      ? document.querySelector('[data-product-terms-checkbox-input][data-terms-product="' + productId + '"]')
      : null;

    return !checkbox || checkbox.checked;
  }

  function setButtonLoading(button, isLoading) {
    if (!button) return;

    button.classList.toggle('is-loading', isLoading);
    button.disabled = isLoading;
  }

  function notifyCartUpdated(response, form) {
    var root = getAjaxCartRoot();

    return fetch(root + 'cart.js', { method: 'GET' })
      .then(function (cartResponse) {
        return cartResponse.json();
      })
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          detail: { cart: cart, open: true }
        }));
        document.dispatchEvent(new CustomEvent('cart:updated', {
          detail: { cart: cart, response: response, source: 'complete-kit' }
        }));
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          detail: { cart: cart, response: response, form: form }
        }));

        if (
          document.querySelector('cart-drawer, cart-drawer-component') &&
          window.Shopify &&
          window.Shopify.actions &&
          typeof window.Shopify.actions.openCart === 'function'
        ) {
          window.Shopify.actions.openCart();
        }

        if (window.upside && window.upside.ucd && window.upside.ucd.helpers && window.upside.ucd.helpers.ajaxCart) {
          if (typeof window.upside.ucd.helpers.ajaxCart.buildCart === 'function') {
            window.upside.ucd.helpers.ajaxCart.buildCart(cart);
          } else if (typeof window.upside.ucd.helpers.ajaxCart.load === 'function') {
            window.upside.ucd.helpers.ajaxCart.load();
          }
        }
      });
  }

  function submitKitCart(form, button, event) {
    var kitItems = getFormKitItems(form);
    var payload;
    var root;

    if (!kitItems.length) return false;

    event.preventDefault();
    event.stopImmediatePropagation();

    if (!termsAccepted(form)) {
      showTermsMessage(form);
      return true;
    }

    payload = buildKitCartPayload(form, kitItems);
    root = getAjaxCartRoot();

    setButtonLoading(button, true);

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Cart add failed');
          }

          return data;
        });
      })
      .then(function (data) {
        return notifyCartUpdated(data, form);
      })
      .catch(function (error) {
        console.error('Complete kit add to cart failed:', error);
        window.alert(error.message || 'Unable to add the complete kit to cart.');
      })
      .finally(function () {
        setButtonLoading(button, false);
      });

    return true;
  }

  function bindCompleteKitCartSubmit() {
    if (window.completeKitCartSubmitBound) return;

    window.completeKitCartSubmitBound = true;

    document.addEventListener('click', function (event) {
      var button = event.target.closest ? event.target.closest('[data-btn-addtocart]') : null;
      var form = button ? button.closest('[data-type="add-to-cart-form"]') : null;

      if (form) {
        submitKitCart(form, button, event);
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target && event.target.matches && event.target.matches('[data-type="add-to-cart-form"]')
        ? event.target
        : null;
      var button = form ? form.querySelector('[data-btn-addtocart]') : null;

      if (form) {
        submitKitCart(form, button, event);
      }
    }, true);
  }

  function positionCompleteKit(root) {
    var form = getProductForm(root);
    var buttons = form ? form.querySelector('.product-form__buttons') : null;
    var wrapper = root.closest('.productView-moreItem') || root;
    var selectedInput = root.querySelector('[data-complete-kit-selected-items]');

    if (!buttons || !buttons.parentNode || !wrapper) return;
    if (selectedInput) syncSelectedItemsToForm(root, selectedInput.value);
    if (wrapper.parentNode === buttons.parentNode && wrapper.nextElementSibling === buttons) return;

    wrapper.classList.add('product-complete-kit__form-wrapper');
    buttons.parentNode.insertBefore(wrapper, buttons);
  }

  function initRoot(root) {
    if (root.dataset.completeKitReady === 'true') return;
    root.dataset.completeKitReady = 'true';
    bindCompleteKitCartSubmit();
    positionCompleteKit(root);
    setTimeout(function () {
      positionCompleteKit(root);
    }, 300);
    setTimeout(function () {
      positionCompleteKit(root);
    }, 1200);

    var toggle = root.querySelector('[data-complete-kit-toggle]');
    var body = root.querySelector('[data-complete-kit-body]');
    var groups = Array.prototype.slice.call(root.querySelectorAll('[data-complete-kit-group]')).map(function (row) {
      return buildGroup(root, row);
    });

    if (toggle && body) {
      toggle.addEventListener('click', function () {
        var isOpen = root.classList.toggle('is-open');
        body.hidden = !isOpen;
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      });
    }

    groups.forEach(function (group) {
      renderGroup(group);

      if (group.addButton) {
        group.addButton.addEventListener('click', function () {
          if (!group.selectedProduct || !group.selectedVariant) return;

          group.selected = !group.selected;
          renderGroup(group);
          updateSelectedItems(root, groups);
        });
      }

      group.swatches.forEach(function (swatch) {
        swatch.addEventListener('click', function () {
          var product = group.products.find(function (item) {
            return String(item.id) === String(swatch.dataset.productId);
          });

          if (!product) return;
          if (!product.available || !firstAvailableVariant(product)) return;

          selectProduct(group, product);
          renderGroup(group);
          updateSelectedItems(root, groups);
        });
      });

      if (group.sizeSelect) {
        group.sizeSelect.addEventListener('change', function () {
          var variant = group.selectedProduct.variants.find(function (item) {
            return String(item.id) === String(group.sizeSelect.value);
          });

          if (!variant) return;

          group.selectedVariant = variant;
          renderGroup(group);
          updateSelectedItems(root, groups);
        });
      }
    });

    updateSelectedItems(root, groups);
  }

  function initCompleteKits() {
    document.querySelectorAll('[data-complete-kit]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCompleteKits);
  } else {
    initCompleteKits();
  }

  document.addEventListener('shopify:section:load', initCompleteKits);
})();
